import { LayoutGrid } from "lucide-react";

const CircleIcon = ({ className }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <circle
      cx="10"
      cy="10"
      r="8"
      stroke="currentColor"
      strokeWidth="2"
      fill="none"
    />
    <circle
      cx="10"
      cy="10"
      r="4"
      stroke="currentColor"
      strokeWidth="2"
      fill="none"
    />
  </svg>
);

const CustomSwitch = ({ checked, onChange }) => {
  return (
    <button
      onClick={() => onChange(!checked)}
      className="relative w-[75px] h-[38px] bg-[#F4F4F5] rounded-full transition-colors duration-200"
    >
      <div className="flex items-center justify-between w-full h-full px-3 relative z-10">
        <LayoutGrid
          size={20}
          className={checked ? "text-[#F0A7D6]" : "text-gray-500"}
        />
        <CircleIcon className={checked ? "text-gray-500" : "text-[#F0A7D6]"} />
      </div>
      <div
        className={`
          absolute w-[32px] h-[32px] bg-white rounded-full shadow-md 
          top-[3px] transition-transform duration-200 z-0
          ${
            !checked
              ? "transform translate-x-[47px] left-[-10px]"
              : "transform translate-x-0 left-[5.5px]"
          }
        `}
      />
    </button>
  );
};

export default CustomSwitch;
